import { z } from "zod";
import { WebPriceSchema } from "@superwall-me/schema";
const WebPriceArraySchema = z.array(WebPriceSchema);
export const parseWebProduct = (webProduct)=>{
    const prices = webProduct.prices ? WebPriceArraySchema.parse(webProduct.prices) : [];
    //@ts-ignore
    return {
        ...webProduct,
        ...typeof webProduct.prices != "undefined" ? {
            prices
        } : {}
    };
};
